import {remCalc} from '../_utils'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const card = {
    backgroundColor: 'white',
}

const cardBordered = {...card}

const page = {
    px: ['small.base', 'small.base', 'large.base', 'large.base', 'large.base', 0],
    width: '100%',
    maxWidth: 'container.xxl',
    marginLeft: 'auto',
    marginRight: 'auto',
}

const layerStyles = {
    layerStyles: {
        'full-width': {
            maxWidth: 'container.xxl',
        },
        card,

        cardBordered,

        ccIcon: {
            width: remCalc(34),
            height: remCalc(22),
        },

        page,

        pageCheckout: {
            ...page,
            py: {base: remCalc(24), md: remCalc(80)},
        },
    },
}

export default layerStyles
